async function AddComponent(designId, componentId, userId, CFM, diameter, entryFactor, length, pressureLoss, velocity, typeOfPipe, notes) {

    if (
        designId.length > 0 &&
        componentId.length > 0 &&
        userId.length > 0
    ) {

        let response;

        let params =
            JSON.stringify(
                {
                    "designId": designId,
                    "componentId": componentId,
                    "userId": userId,
                    "CFM": CFM,
                    "diameter": diameter,
                    "entryFactor": entryFactor,
                    "length": length,
                    "pressureLoss": pressureLoss,
                    "velocity": velocity,
                    "typeOfPipe": typeOfPipe,
                    "notes": notes
                });

        response = await fetch("https://api.cssi.co/CNF/AddComponent", {
            method: "POST",
            body: params

        })
            .then(response => {
                return response.json();
            })
            .catch(e => {
                e.name === "AbortError" ? console.log("Fetch Aborted") : console.log(e.message);
            })
        return Promise.resolve(response);
    }
}

export default AddComponent;